import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { accessibilityConfig } from "./config";
import { AccessibilityDirective } from "./directives/accessibility.directive";
import { FocusTabButtonDirective } from "./directives/focus-tab-btn.directive";
import { FocusTabDirective } from "./directives/focus-tab.directive";
import { AccessibilityService, ACCESSIBILITY_CONFIG } from "./services/accessibility.service";

@NgModule({
    declarations: [
        AccessibilityDirective,
        FocusTabDirective,
        FocusTabButtonDirective
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    providers: [
        AccessibilityService,
        {
            provide: ACCESSIBILITY_CONFIG,
            useValue: accessibilityConfig
        }
    ],
    exports: [
        AccessibilityDirective,
        FocusTabDirective,
        FocusTabButtonDirective
    ]
})
export class AccessibilityModule{
}